// Placeholder phone number assigned to accounts that never set a real one — treat as missing, not just unverified.
export const FALLBACK_PHONE = '+46000000000'
